import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "filter" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, "Fai un preventivo per l’assicurazione di viaggio", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "filter-row" }, null, -1)
const _hoisted_4 = { class: "webins-preventivatore-row" }
const _hoisted_5 = { style: {"margin":"10px"} }
const _hoisted_6 = { style: {"margin":"10px"} }
const _hoisted_7 = { style: {"margin":"10px"} }
const _hoisted_8 = { style: {"margin":"10px"} }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"20px","margin-top":"15px","font-size":"20px"} }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mb-1" }, "Viaggiatori per fascia d'età")
], -1)
const _hoisted_10 = {
  class: "webins-preventivatore-row",
  style: {"margin-top":"15px"}
}
const _hoisted_11 = {
  key: 0,
  class: "webins-preventivatore-row",
  style: {"margin-top":"15px"}
}
const _hoisted_12 = { style: {"margin":"10px"} }
const _hoisted_13 = {
  key: 1,
  class: "webins-preventivatore-row",
  style: {"margin-top":"15px"}
}
const _hoisted_14 = { style: {"margin":"10px"} }
const _hoisted_15 = {
  key: 0,
  style: {"margin":"10px"}
}
const _hoisted_16 = {
  class: "center",
  style: {"margin-top":"15px"}
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["innerHTML"]

import { computed, ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import dayjs from "dayjs";
import { useWidget, useNavigation, usePolizze } from "@/composables";
import { ParametriPreventivatoreFasceEta, ParametriPreventivatoreItem } from "@/models/ParametriPreventivatore";
import CustomInput from "@/components/custom-input.vue";
import Popup from "@/components/popup.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t } = useI18n();
const { destinazioniPreventivatore, elencoEta, elencoFasceEta, datiIniziali, widgetConfig, decodificaStato } = useWidget();
const { getPreventivatore, loading, getParametriSchedaPreventivatore, parametriPreventivatore } = usePolizze();
const { next } = useNavigation();

const today = ref(dayjs().toDate());
const fineViaggioMinimo = ref(dayjs().toDate());
const dataPrenotazione = ref(dayjs());
const inizioViaggio = ref(dayjs());
const fineViaggio = ref(dayjs());
const destinazioneStato = ref();
const etaModel = ref(0);
const codiceCoupon = ref("");
const numeroPartecipanti = ref<number>();
const importoViaggio = ref<number>();

const popupAlert = ref(null);
const alertText = ref("");
const usaFasce = ref<boolean>(false);
const usaImportoViaggio = ref<boolean>(false);

const numeroPartecipantiPerFascia = ref<ParametriPreventivatoreFasceEta[]>([]);

const hintDataPrenotazione = ref<boolean>(false);
const hintDestinazione = ref<boolean>(false);

for (var i = 0; i < elencoFasceEta.value.length; i++)
    numeroPartecipantiPerFascia.value.push({ idFascia: elencoFasceEta.value[i].itemID, descrizione: elencoFasceEta.value[i].descrizione, numeroPartecipanti: null });

onMounted(() => {
    if(widgetConfig.value && widgetConfig.value.abilitaAggiuntaCarrello)
        return;

    //dataPrenotazione.value = dayjs(today.value);
    usaFasce.value = widgetConfig.value && widgetConfig.value.usaFasceEta ? true : false;
    usaImportoViaggio.value = widgetConfig.value && widgetConfig.value.usaImportoViaggio ? true : false;

    if (parametriPreventivatore && parametriPreventivatore.value) {
        parametriPreventivatore.value.dataPrenotazione && (dataPrenotazione.value = dayjs(parametriPreventivatore.value.dataPrenotazione));
        parametriPreventivatore.value.destinazioneStato && (destinazioneStato.value = parametriPreventivatore.value.destinazioneStato);
        parametriPreventivatore.value.inizioViaggio && (inizioViaggio.value = dayjs(parametriPreventivatore.value.inizioViaggio));
        parametriPreventivatore.value.fineViaggio && (fineViaggio.value = dayjs(parametriPreventivatore.value.fineViaggio));
        parametriPreventivatore.value.numeroPartecipanti && (numeroPartecipanti.value = parametriPreventivatore.value.numeroPartecipanti);
        parametriPreventivatore.value.eta && (etaModel.value = parametriPreventivatore.value.eta);
        parametriPreventivatore.value.codiceCoupon && (codiceCoupon.value = parametriPreventivatore.value.codiceCoupon);

        if(usaImportoViaggio.value){
            parametriPreventivatore.value.importoViaggio && (importoViaggio.value = parametriPreventivatore.value.importoViaggio);
        }

        if (parametriPreventivatore.value.fasceEta && parametriPreventivatore.value.fasceEta.length) {
            for (var i = 0; i < parametriPreventivatore.value.fasceEta.length; i++) {
                var f = numeroPartecipantiPerFascia.value.find((obj) => obj.idFascia === parametriPreventivatore.value.fasceEta[i].idFascia);
                f && parametriPreventivatore.value.fasceEta[i].numeroPartecipanti && (f.numeroPartecipanti = parametriPreventivatore.value.fasceEta[i].numeroPartecipanti);
            }
        }
    }
    if (datiIniziali && datiIniziali.value) {
        !parametriPreventivatore.value.dataPrenotazione && datiIniziali.value.dataPrenotazione && (dataPrenotazione.value = dayjs(datiIniziali.value.dataPrenotazione));
        !destinazioneStato.value && datiIniziali.value.destinazione && (destinazioneStato.value = decodificaStato(datiIniziali.value.destinazione));
        !parametriPreventivatore.value.inizioViaggio && datiIniziali.value.inizioViaggio && (inizioViaggio.value = dayjs(datiIniziali.value.inizioViaggio));
        !parametriPreventivatore.value.fineViaggio && datiIniziali.value.fineViaggio && (fineViaggio.value = dayjs(datiIniziali.value.fineViaggio));
        !numeroPartecipanti.value && datiIniziali.value.numeroPartecipanti && (numeroPartecipanti.value = datiIniziali.value.numeroPartecipanti);
        //!etaModel.value && datiIniziali.value.fasciaEta && (etaModel.value = elencoEta.value[datiIniziali.value.fasciaEta - 1].value);
        !parametriPreventivatore.value.codiceCoupon && datiIniziali.value.codiceCoupon && (codiceCoupon.value = datiIniziali.value.codiceCoupon);

        if(usaImportoViaggio.value){
            !importoViaggio.value && datiIniziali.value.importoViaggio && (importoViaggio.value = datiIniziali.value.importoViaggio);
        }

        if (!parametriPreventivatore.value.fasceEta || !parametriPreventivatore.value.fasceEta.length) {
            if (datiIniziali.value.fasceEta && datiIniziali.value.fasceEta.length) {
                for (var i = 0; i < datiIniziali.value.fasceEta.length; i++) {
                    var f = numeroPartecipantiPerFascia.value.find((obj) => obj.idFascia === datiIniziali.value.fasceEta[i].idFascia);
                    f && datiIniziali.value.fasceEta[i].numeroPartecipanti && (f.numeroPartecipanti = datiIniziali.value.fasceEta[i].numeroPartecipanti);
                }
            }
        }
    }
});

const searchDisabled = computed(() => false);

const dataPrenotazioneModel = computed({
    get(): string {
        return dataPrenotazione.value.format("YYYY-MM-DD");
    },
    set(newValue: string): void {
        dataPrenotazione.value = dayjs(newValue);
    }
});

const inizioViaggioModel = computed({
    get(): Date {
        //return inizioViaggio.value.format("YYYY-MM-DD");
        return inizioViaggio.value ? inizioViaggio.value.toDate() : null;
    },
    set(newValue: Date): void {
        inizioViaggio.value = dayjs(newValue);

        if (inizioViaggio.value && inizioViaggio.value.isValid()) {
            //fineViaggioMinimo.value = inizioViaggio.value.format("YYYY-MM-DD");
            fineViaggioMinimo.value = inizioViaggio.value.toDate();

            if (inizioViaggio.value > fineViaggio.value) {
                fineViaggio.value = inizioViaggio.value;
            }
        } else {
            fineViaggio.value = dayjs();
            //fineViaggioMinimo.value = dayjs().format("YYYY-MM-DD");
            fineViaggioMinimo.value = dayjs().toDate();
        }
    }
});

const fineViaggioModel = computed({
    get(): Date {
        return fineViaggio.value.toDate();
    },
    set(newValue: Date): void {
        fineViaggio.value = dayjs(newValue);
    }
});

const search = async () => {
    var nPart = numeroPartecipanti.value;
    if (!nPart || isNaN((nPart = parseInt(String(nPart))))) nPart = null;

    console.log("Parametri in ingresso: " + JSON.stringify(datiIniziali.value));
    debugger
    let parametri: ParametriPreventivatoreItem = {
        dataPrenotazione: dataPrenotazione.value && dataPrenotazione.value.isValid() ? dataPrenotazione.value.toDate() : null,
        inizioViaggio: inizioViaggio.value && inizioViaggio.value.isValid() ? inizioViaggio.value.toDate() : null,
        fineViaggio: fineViaggio.value && fineViaggio.value.isValid() ? fineViaggio.value.toDate() : null,
        destinazioneStato: destinazioneStato.value ? parseInt(destinazioneStato.value) : null,
        eta: etaModel.value,
        numeroPartecipanti: nPart && nPart > 0 ? nPart : null,
        fasceEta: [],
        codiceCoupon: codiceCoupon.value || null,
        importoViaggio: usaImportoViaggio.value ? importoViaggio.value || 0 : 0,
        prodottiSelezionati: []
    };

    
    console.log("Parametri rielaborati: " + JSON.stringify(parametri));

    if (usaFasce.value) {
        var totPartSpecificati = 0;
        for (var i = 0; i < numeroPartecipantiPerFascia.value.length; i++) {
            var n = parseInt(String(numeroPartecipantiPerFascia.value[i].numeroPartecipanti));
            if (!n || isNaN(n) || n < 0) numeroPartecipantiPerFascia.value[i].numeroPartecipanti = null;
            else numeroPartecipantiPerFascia.value[i].numeroPartecipanti = n;

            parametri.fasceEta.push(JSON.parse(JSON.stringify(numeroPartecipantiPerFascia.value[i])));
            totPartSpecificati += numeroPartecipantiPerFascia.value[i].numeroPartecipanti || 0;
        }

        if (!totPartSpecificati) {
            alertText.value = "Impostare almeno un partecipante";
            popupAlert.value.show();
            return;
        }

        parametri.numeroPartecipanti = totPartSpecificati;
    }
    else{

        if (!parametri.numeroPartecipanti || parametri.numeroPartecipanti < 0) {
            alertText.value = "Impostare almeno un partecipante";
            popupAlert.value.show();
            return;
        }
        parametri.fasceEta = [ { idFascia: 0, numeroPartecipanti: parametri.numeroPartecipanti, descrizione: ""}];
    }

    
    console.log("OK 1");

    if (!parametri.inizioViaggio || !parametri.fineViaggio || !parametri.destinazioneStato) {
        alertText.value = "Inserire tutti i parametri per avviare la ricerca";
        popupAlert.value.show();
        return;
    }

    console.log("Richiamo preventivaore");
    await getPreventivatore(parametri);

    await getParametriSchedaPreventivatore();

    next();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(CustomInput, {
          placeHolder: 'Destinazione',
          hint: 'In caso di viaggio con più destinazioni, indicare il Paese più distante. Fermo restando i massimali previsti per ciascuna destinazione. Quando una delle tappe è USA o Canada, indicare sempre una di queste due destinazioni.',
          type: 'select',
          optionLabel: 'Seleziona un\'opzione',
          dataSource: _unref(destinazioniPreventivatore),
          value: destinazioneStato.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((destinazioneStato).value = $event))
        }, null, 8, ["hint", "dataSource", "value"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(CustomInput, {
          placeHolder: 'Data inizio viaggio',
          type: 'date',
          value: _unref(inizioViaggioModel),
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_isRef(inizioViaggioModel) ? (inizioViaggioModel).value = $event : null)),
          minDate: today.value
        }, null, 8, ["value", "minDate"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(CustomInput, {
          placeHolder: 'Data fine viaggio',
          type: 'date',
          value: _unref(fineViaggioModel),
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_isRef(fineViaggioModel) ? (fineViaggioModel).value = $event : null)),
          minDate: fineViaggioMinimo.value
        }, null, 8, ["value", "minDate"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(CustomInput, {
          placeHolder: 'Codice Promozionale',
          type: 'string',
          value: codiceCoupon.value,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((codiceCoupon).value = $event))
        }, null, 8, ["value"])
      ])
    ]),
    (usaFasce.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(elencoFasceEta), (fascia, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                style: {"margin":"10px"}
              }, [
                _createVNode(CustomInput, {
                  placeHolder: fascia.descrizione,
                  type: 'number',
                  value: numeroPartecipantiPerFascia.value[i].numeroPartecipanti,
                  "onUpdate:value": ($event: any) => ((numeroPartecipantiPerFascia.value[i].numeroPartecipanti) = $event)
                }, null, 8, ["placeHolder", "value", "onUpdate:value"])
              ]))
            }), 128))
          ]),
          (usaImportoViaggio.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(CustomInput, {
                    placeHolder: 'Importo Viaggio ( € )',
                    type: 'number',
                    value: importoViaggio.value,
                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((importoViaggio).value = $event))
                  }, null, 8, ["placeHolder", "value"])
                ])
              ]))
            : _createCommentVNode("", true)
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(CustomInput, {
              placeHolder: 'Numero Partecipanti',
              type: 'number',
              value: numeroPartecipanti.value,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((numeroPartecipanti).value = $event))
            }, null, 8, ["value"])
          ]),
          (usaImportoViaggio.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(CustomInput, {
                  placeHolder: 'Importo Viaggio ( € )',
                  type: 'number',
                  value: importoViaggio.value,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((importoViaggio).value = $event))
                }, null, 8, ["placeHolder", "value"])
              ]))
            : _createCommentVNode("", true)
        ])),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("button", {
        class: "btn",
        onClick: search,
        disabled: _unref(searchDisabled)
      }, _toDisplayString(_unref(t)("step0.btn")), 9, _hoisted_17)
    ]),
    _createVNode(Popup, {
      ref_key: "popupAlert",
      ref: popupAlert
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          style: {"font-weight":"bold"},
          innerHTML: alertText.value
        }, null, 8, _hoisted_18)
      ]),
      _: 1
    }, 512)
  ]))
}
}

})